import { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import AuctionComplexItem from './components/AuctionComplexItem';

import MapService from '../../service/map/Map';
import Loading from '../../func/components/loading/LoadingCircle';
import {
  createCustomOverlay,
  getTypeColor,
  hospitalMarkesSVG,
  makeMarkers,
  publicOfficeMarkesSVG,
  schoolMarkesSVG,
  trafficMakersSVG,
} from './markerInfo';
import { ConvertDataByType, getPriceByType } from './func/function';
import MapFilter from '../map/component/MapFilter';
import { useMapContext } from '../../context/MapContext';
import RealDealList from '../map/component/RealDealList';
import { useMapFilterContext } from '../../context/MapFilterContext';
import constructWithOptions from 'styled-components/dist/constructors/constructWithOptions';
import { useLocation } from 'react-router-dom';
import { addDotMarker } from './DotMarker';
const { kakao }: any = window;

declare global {
  interface Window {
    kakao: any;
  }
}

const MapBox = ({ markerData, bounds, setBounds, getMarkerList }: any) => {
  const location = useLocation();
  const prevClickedMarkerId = useRef<string | null>(null);

  const [map, setMap] = useState<any>(null);
  const mapRef = useRef<HTMLDivElement | null>(null);
  const ignoreClearRef = useRef(false);

  // const [isMarkerClicked, setIsMarkerClicked] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const [onTraffic, setOnTraffic] = useState(false);
  const [onSchool, setOnSchool] = useState(false);
  const [onPublicOffice, setOnPublicOffice] = useState(false);
  const [onHospital, setOnHospital] = useState(false);
  const [markerList, setMarkerList] = useState<any[]>([]);
  const [markerListOverlay, setMarkerListOverlay] = useState<
    kakao.maps.CustomOverlay[]
  >([]);
  const [makrerDetailData, setMakrerDetailData] = useState<any>({});
  const [filteredDetailData, setFilteredDetailData] = useState<any[]>([]);
  const [selectedAddress, setSelectedAddress] =
    useState('서울특별시 서초구 서초대로 294');
  const [region, setRegion] = useState({
    sido: '',
    gugun: '',
    dong: '',
  });

  const hoverPinRef = useRef<{
    pinnedOverlay: kakao.maps.CustomOverlay | null;
    pinnedId: string | null;
  }>({
    pinnedOverlay: null,
    pinnedId: null,
  });

  const [selectedMarkerOverlay, setSelectedMarkerOverlay] =
    useState<kakao.maps.CustomOverlay | null>(null);

  const {
    setOnRealDealList,
    setIidx,
    setModalOn,
    onRealDealList,
    setMarkerType,
    setMarkerCategory,
    setDetailIdx,
    setDetailModalOn,
    setDetailType,
    mapFilter,
    setMapFilter,
  } = useMapContext();

  const {
    zoomLevel,
    mapType,
    overlayType,
    setZoomLevel,
    isTotalPrice,
    isPyeonPrice,
    latLng,
    setLatLng,
    onPublicPrice,
    markerType,
    setSelectedItemInfo2,
    selectedItemInfo2,
    markerDetail,
    setMarkerDetail,
  } = useMapFilterContext();

  const [height, setHeight] = useState(35);
  const [initialHeight, setInitialHeight] = useState(0);
  const startYRef = useRef<number | null>(null);
  const startHeightRef = useRef<number>(height);

  const handleTouchStart = (e: React.TouchEvent) => {
    startYRef.current = e.touches[0].clientY;
    startHeightRef.current = height;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (startYRef.current === null) return;
    if (height >= 90) return;
    const deltaY = startYRef.current - e.touches[0].clientY;

    const newHeight = Math.min(
      Math.max(
        startHeightRef.current + (deltaY / window.innerHeight) * 100,
        10,
      ),
      100,
    );

    setHeight(newHeight);
    if (height === initialHeight && deltaY > 10) {
      setHeight(100); // 위로 드래그하면 전체화면
      e.preventDefault(); // 내부 스크롤 막기
    }
  };

  const handleTouchEnd = () => {
    if (height < initialHeight) {
      setModalOpen(false);
      setMarkerDetail(null);
      // setIsMarkerClicked(false);
    } else if (height > initialHeight && height < 100) {
      setHeight(initialHeight);
    } else if (height > initialHeight) {
      setHeight(100);
    }
    startYRef.current = null;
  };

  const getBottomSheetHeight = (data: any) => {
    const viewportHeight = window.innerHeight;
    const handlerHeight = 18;
    const bottomPadding = 16;
    const baseHeight = 20;
    if (data.length === 1) {
      return (220 / viewportHeight) * 100;
    } else {
      return (250 / viewportHeight) * 100;
    }

    // const firstData = data?.auction_list
    //   ? data.auction_list[0]
    //   : data?.ex_list
    //     ? data?.ex_list[0]
    //     : data?.realdeal
    //       ? data.realdeal
    //       : null;
    // if (firstData) {
    //   const addrLength = firstData?.addr?.length || 0;

    //   const addrLines = addrLength > 20 ? 2 : 1;
    //   const firstListHeight = 155 + baseHeight * addrLines;

    //   const totalPxHeight = firstListHeight + handlerHeight + bottomPadding;

    //   return (totalPxHeight / viewportHeight) * 100;
    // } else {
    //   return 27;
    // }
  };

  const getMarkerDetail = async (detailData: any) => {
    if (!detailData || Object.keys(detailData).length === 0 || !detailData.iidx)
      return;

    try {
      const res = await MapService.makerDetail2(
        detailData.type.toUpperCase().trim(),
        detailData.iidx,
        mapFilter.multiItemStatus.join(','),
        mapFilter?.progressStatus.join(','),
        detailData.specialCondition,
        detailData.specialItems,
        mapFilter.type,
      );
      setMakrerDetailData(res.data);
      setSelectedAddress(res.data.addr);
    } catch (e) {
      console.error(e);
    }
  };

  // 지도 생성
  useEffect(() => {
    if (window.kakao && window.kakao.maps) {
      setMakrerDetailData(null);
      setMarkerDetail(null);
      const container = document.getElementById('newMap');
      // 기존 지도 제거
      if (container) {
        container.innerHTML = ''; // 기존 DOM 초기화
      }

      const changeMaptype = (mapType: string) => {
        if (mapType === 'ROADMAP') return kakao.maps.MapTypeId.ROADMAP;
        if (mapType === 'HYBRID') return kakao.maps.MapTypeId.HYBRID;
        return kakao.maps.MapTypeId.ROADMAP;
      };
      const options = {
        center: new window.kakao.maps.LatLng(
          latLng?.lat ?? 37.4934705,
          latLng?.lng ?? 127.0142285,
        ),
        draggable: true,
        // scrollwheel: false,
        level: zoomLevel,
        disableDoubleClickZoom: true, // 더블클릭 확대 비활성화
        mapTypeId: changeMaptype(mapType),
        maxLevel: 10,
      };

      let map: kakao.maps.Map;
      // 지도 생성
      map = new window.kakao.maps.Map(container, options);
      // 지도 중심 좌표 가져오기
      setMap(map);

      const bounds = map.getBounds();
      const swLatlng = bounds.getSouthWest();
      const neLatlng = bounds.getNorthEast();

      setBounds({
        swLat: swLatlng.getLat(),
        swLng: swLatlng.getLng(),
        neLat: neLatlng.getLat(),
        neLng: neLatlng.getLng(),
      });

      if (overlayType === 'USE_DISTRICT') {
        map.removeOverlayMapTypeId(window.kakao.maps.MapTypeId.USE_DISTRICT);
        map.addOverlayMapTypeId(window.kakao.maps.MapTypeId.USE_DISTRICT);
      } else {
        map.removeOverlayMapTypeId(window.kakao.maps.MapTypeId.USE_DISTRICT);
      }

      // 지도 중심 이동 후 bounds 업데이트
      kakao.maps.event.addListener(map, 'idle', function () {
        const mapBounds = map.getBounds();
        const latLng_swLatlng = mapBounds.getSouthWest();
        const latLng_neLatlng = mapBounds.getNorthEast();

        const newBounds = {
          swLat: latLng_swLatlng.getLat(),
          swLng: latLng_swLatlng.getLng(),
          neLat: latLng_neLatlng.getLat(),
          neLng: latLng_neLatlng.getLng(),
        };
        setBounds(newBounds);
      });

      //줌이 변경될 경우 변경된 값 저장
      kakao.maps.event.addListener(
        map as kakao.maps.Map, // map 변수를 kakao.maps.Map 타입으로 캐스팅
        'zoom_changed',
        function () {
          if (ignoreClearRef.current) {
            ignoreClearRef.current = false;
            return;
          }
          const level = (map as kakao.maps.Map).getLevel(); // map을 kakao.maps.Map으로 명시적으로 캐스팅
          setZoomLevel(level);
          setMarkerDetail(null);
        },
      );

      // 지도 클릭 시 상세보기 닫기
      kakao.maps.event.addListener(map, 'click', function () {
        setMarkerDetail(null);
      });
      kakao.maps.event.addListener(map, 'dragend', function () {
        setMarkerDetail(null);
      });
    }
  }, []);

  useEffect(() => {
    if (!map) return; // 지도 준비된 뒤에만

    const search = new URLSearchParams(location.search);

    const lat = Number(search.get('lat'));
    const lng = Number(search.get('lng'));
    if (lat && lng && Number.isFinite(lat) && Number.isFinite(lng)) {
      // setLatLng({ lat, lng });
      setZoomLevel(2); // 상세 마커 잘 보이도록 적당한 레벨
    } else {
      getUserLocation();
    }

    const openParam = search.get('open');
    if (openParam) {
      try {
        const m = JSON.parse(decodeURIComponent(openParam));
        setMarkerDetail({
          type: String(m.type).trim(),
          iidx: Number(m.iidx),
          item_code: m.item_code ?? '',
          prc: Number(m.prc) || 0,
          pnu: 0,
          pyeong: 0,
          area: 0,
          date: m.date ?? '',
          lat: Number(m.lat),
          lng: Number(m.lng),
          specialCondition: m.specialCondition ?? '',
          specialItems: m.specialItems ?? '',
        });
        ignoreClearRef.current = true;
        setMapFilter({
          ...mapFilter,
          type: String(m.type).trim().toUpperCase(),
          progressStatus: m.status.split(',') ?? '',
        });
      } catch (e) {
        console.error('open param parse error', e);
      }
    }
  }, [map, location.search]);

  // 지도 이동 업데이트
  useEffect(() => {
    if (!map || !latLng) return;

    const newCenter = new kakao.maps.LatLng(latLng.lat, latLng.lng);
    map.panTo(newCenter);
  }, [latLng]);

  useEffect(() => {
    if (!map) return;

    map.setLevel(zoomLevel);
  }, [zoomLevel]);

  useEffect(() => {
    setMarkerList(markerData);
    setSelectedAddress(markerData[0]?.pnu || '서울특별시 서초구 서초대로 294');
  }, [markerData]);

  const resetHoverPin = () => {
    const s = hoverPinRef.current;
    if (s.pinnedOverlay) {
      s.pinnedOverlay.setMap(null);
      s.pinnedOverlay = null;
      s.pinnedId = null;
    }
  };

  const RendingMarker = (data: any) => {
    if (markerList.length === 0) return;

    const newMarkers: kakao.maps.CustomOverlay[] = [];

    // if (!Array.isArray(data) || data.length === 0 || !map) {
    //   // 기존 오버레이만 정리할지 여부는 선택
    //   return;
    // }

    if (zoomLevel >= 6) {
      //클러스터로 될 때는 마커가 또지 않게 수정

      // 줌 레벨이 6 이상일 때 `overlevel6MarkerData`를 사용하여 커스텀 오버레이 생성
      data.forEach((data: any) => {
        const overlay = createCustomOverlay(data, kakao);
        const makerElement = document.getElementById(`cluster-${data.code}`);

        setTimeout(() => {
          const markerElement = document.getElementById(`cluster-${data.code}`);
          if (markerElement) {
            markerElement.removeEventListener('click', handleClusterClick);
            markerElement.addEventListener('click', handleClusterClick);
          }
        }, 0); // DOM이 렌더링된 후 바로 이벤트 리스너를 추가
        overlay.setMap(map);
        newMarkers.push(overlay);

        async function handleClusterClick() {
          try {
            const regionCode = String(data.code);

            // zoomLevel이 6 또는 7일 때만 getRegionList 호출
            if (zoomLevel >= 6 && zoomLevel <= 7) {
              const res = await MapService.getRegionList({
                regionCode: String(data.code),
                name: data.name,
                swLat: bounds.swLat,
                swLng: bounds.swLng,
                neLat: bounds.neLat,
                neLng: bounds.neLng,

                status: Array.isArray(mapFilter?.progressStatus)
                  ? mapFilter.progressStatus.join(',')
                  : (mapFilter?.progressStatus ?? ''),
                specialCondition: mapFilter?.specialItemCond ?? '',
                specialItems: mapFilter?.specialItemCondition?.join(',') ?? '',

                itemCode: '',
                sort: 'DA',
              });

              const items = res.data?.list ?? [];

              if (items.length > 0) {
                const first = items[0];
                if (first.lat && first.lng) {
                  setLatLng({ lat: Number(first.lat), lng: Number(first.lng) });
                  setZoomLevel(3);
                } else {
                  getSubMarker(data);
                }
              } else {
                getSubMarker(data);
              }
            } else {
              getSubMarker(data);
            }
          } catch (e) {
            getSubMarker(data);
          }
        }
      });
    } else if (zoomLevel === 5) {
      const filteredData = data.filter((data: any) => {
        if (mapFilter.type === '') return true;

        const typeArr = mapFilter.type.split(',').map((t: string) => t.trim());
        if (typeArr.includes('N')) {
          if (['A', 'P', 'N'].includes(data.type)) return true;
        }

        return typeArr.includes(data.type);
      });

      //중복 제거를 위해 set 추가
      const seen = new Set();
      const filteredData2 = filteredData
        .filter((data: any) => {
          if (seen.has(data.marker_idx)) {
            return false;
          }
          seen.add(data.iidx);
          return true;
        })
        .map((data: any) => ({
          ...data,
        }));
      kakao.maps.event.addListener(map, 'click', resetHoverPin);
      kakao.maps.event.addListener(map, 'dragend', resetHoverPin);
      kakao.maps.event.addListener(map, 'zoom_changed', resetHoverPin);

      filteredData2.forEach((item: any) => {
        const priceData = getPriceByType(item, isTotalPrice, isPyeonPrice);
        addDotMarker({
          map,
          kakao,
          item,
          priceData,
          markerDetail,
          setMarkerDetail,
          newMarkers,
          mapFilter,
          s: hoverPinRef.current,
        });
      });
    } else {
      const filteredData = data.filter((data: any) => {
        if (mapFilter.type === '') return true;

        const typeArr = mapFilter.type.split(',').map((t: string) => t.trim());
        if (typeArr.includes('N')) {
          if (['A', 'P', 'N'].includes(data.type)) return true;
        }

        return typeArr.includes(data.type);
      });

      //중복 제거를 위해 set 추가
      const seen = new Set();
      const filteredData2 = filteredData
        .filter((data: any) => {
          if (seen.has(data.marker_idx)) {
            return false;
          }
          seen.add(data.marker_idx);
          return true;
        })
        .map((data: any) => ({
          ...data,
        }));

      if (
        markerDetail &&
        !seen.has(markerDetail.iidx) &&
        markerDetail.prc !== 0
      ) {
        const markerId = `marker-${markerDetail.iidx}`;
        const overlay = makeMarkers(
          getPriceByType(markerDetail, isTotalPrice, isPyeonPrice),
          kakao,
          markerId,
          markerDetail,
        );
        if (!overlay) return;
        overlay.setMap(map);
        newMarkers.push(overlay);
      }

      const proj = map.getProjection();
      const bounds = map.getBounds();
      const sw = proj.containerPointFromCoords(bounds.getSouthWest());
      const ne = proj.containerPointFromCoords(bounds.getNorthEast());

      const cellSize = 240; // px
      const left = Math.min(sw.x, ne.x);
      const top = Math.min(sw.y, ne.y);

      // key: `${cx}_${cy}` -> value: item[]
      const cellMap = new Map<string, any[]>();

      for (const item of filteredData2) {
        if (!item.lat || !item.lng) continue;
        const pt = proj.containerPointFromCoords(
          new kakao.maps.LatLng(Number(item.lat), Number(item.lng)),
        );
        const cx = Math.floor((pt.x - left) / cellSize);
        const cy = Math.floor((pt.y - top) / cellSize);
        const key = `${cx}_${cy}`;
        const arr = cellMap.get(key) || [];
        arr.push(item);
        cellMap.set(key, arr);
      }

      kakao.maps.event.addListener(map, 'click', resetHoverPin);
      kakao.maps.event.addListener(map, 'dragend', resetHoverPin);
      kakao.maps.event.addListener(map, 'zoom_changed', resetHoverPin);

      for (const arr of Array.from(cellMap.values())) {
        let normalCount = 0;

        for (const item of arr) {
          const priceData = getPriceByType(item, isTotalPrice, isPyeonPrice);

          if (
            normalCount < 2 ||
            (markerDetail && item.marker_idx === markerDetail.iidx)
          ) {
            // 기본형 2개
            const markerId = `marker-${item.marker_idx}`;
            const overlay = makeMarkers(
              priceData,
              kakao,
              markerId,
              markerDetail,
            );
            if (!overlay) continue;
            overlay.setMap(map);
            newMarkers.push(overlay);

            const handleClick = () => {
              setMarkerDetail({
                type: item.type?.trim(),
                iidx: item.marker_idx,
                item_code: item.item_code,
                prc: item.prc ?? '',
                pnu: item.pnu,
                area: item.area,
                pyeong: item.pyeong,
                date: item.date,
                lat: item.lat,
                lng: item.lng,
                specialCondition: mapFilter?.specialItemCond,
                specialItems:
                  mapFilter?.specialItemCondition?.length === 0
                    ? ''
                    : mapFilter?.specialItemCondition?.join(','),
              });
              setSelectedMarkerOverlay(overlay);
            };

            setTimeout(() => {
              const el = document.getElementById(markerId);
              if (el) {
                window.requestAnimationFrame(() => {
                  el.removeEventListener('click', handleClick);
                  el.addEventListener('click', handleClick);
                });
              }
            }, 0);

            normalCount += 1;
          } else {
            // 초과분 -> 공용 dot 헬퍼
            addDotMarker({
              map,
              kakao,
              item,
              priceData,
              markerDetail,
              setMarkerDetail,
              newMarkers,
              mapFilter,
              s: hoverPinRef.current,
            });
          }
        }
      }
    }
    // 기존 마커 제거 후 새로운 마커 설정
    markerListOverlay.forEach((overlay) => {
      overlay?.setMap(null);
    });

    setMarkerListOverlay(newMarkers);
  };

  useEffect(() => {
    if (!map) return;
    RendingMarker(markerList);
  }, [map, markerList, isTotalPrice, isPyeonPrice, mapFilter]);

  // 마커 클릭 시
  useEffect(() => {
    if (!map) return;
    // 이전 클릭된 마커 초기화
    if (prevClickedMarkerId.current) {
      const prevId = prevClickedMarkerId.current;

      const prevMain = document.getElementById(
        `${prevId}-main-box`,
      ) as HTMLElement | null;
      const prevBody = document.getElementById(
        `${prevId}-body`,
      ) as HTMLElement | null;
      const prevTail = document.getElementById(
        `${prevId}-tail`,
      ) as HTMLElement | null;

      if (prevMain) {
        const type = prevMain.getAttribute('data-type') || '';

        prevMain.style.background = '';
        if (type === 'E') {
          prevMain.style.background = '#FFECD9';
          const label = prevMain.querySelector(
            '.overlay-label',
          ) as HTMLElement | null;
          const category = prevMain.querySelector(
            '.overlay-category',
          ) as HTMLElement | null;

          if (label) {
            label.style.background = '#C86700';
            label.style.color = '#fff';
          }
          if (category) {
            category.style.color = '#C86700';
          }
        }
      }

      if (prevBody) {
        const price = prevBody.querySelector('.overlay-price') as HTMLElement;
        const area = prevBody.querySelector('.overlay-area') as HTMLElement;

        if (price) price.style.color = '#222';
        if (area) area.style.color = '#37383C9C';
      }

      if (prevTail) {
        // 꼬리 원래색 복구 (기본은 #fff, 혹은 back을 쓰는 구성이라면 back으로)
        const back = prevMain?.getAttribute('data-back') || '#fff';
        (prevTail as HTMLElement).style.borderTopColor = back;
      }
    }

    if (
      !markerDetail ||
      Object.keys(markerDetail).length === 0 ||
      markerDetail.iidx === 0
    ) {
      setMakrerDetailData(null);
      return;
    }

    getMarkerDetail(markerDetail);

    const data = markerDetail;

    const id = data.iidx;
    // setMarkerSelectedIidx(data.iidx);

    // 현재 클릭된 마커 강조
    const markerId = `marker-${id}`;
    const maindiv = document.getElementById(`${markerId}-main-box`);
    const body = document.getElementById(`${markerId}-body`);
    const tail = document.getElementById(`${markerId}-tail`);

    if (maindiv) {
      maindiv.style.backgroundColor = `${getTypeColor(data.type).color}`;
      if (data.type.toUpperCase() === 'E') {
        const label = maindiv.querySelector('.overlay-label') as HTMLElement;
        const category = maindiv.querySelector(
          '.overlay-category',
        ) as HTMLElement;

        if (label) {
          label.style.color = `${getTypeColor(data.type).color}`;
          label.style.background = `${getTypeColor(data.type).back}`;
        }
        if (category) category.style.color = '#fff';
      }
    }
    if (body) {
      const price = body.querySelector('.overlay-price') as HTMLElement;
      const area = body.querySelector('.overlay-area') as HTMLElement;

      if (price) price.style.color = '#fff';
      if (area) area.style.color = '#fff';
    }
    if (tail) {
      tail.style.borderTopColor = `${getTypeColor(data.type).color}`;
    }

    // 지도 이동
    if (map && data.lat && data.lng) {
      const viewportHeight = window.innerHeight;

      const bottomSheetHeight =
        window.innerHeight * (getBottomSheetHeight(data) / 100);
      const markerHeight = 60;
      const offsetY = 40;

      const totalOffsetY =
        viewportHeight / 2 - bottomSheetHeight - markerHeight - offsetY;

      const metersPerLatDegree = 111320;
      const offsetLat = totalOffsetY / metersPerLatDegree;

      const targetLat = data.lat + offsetLat;
      const targetPoint = new kakao.maps.LatLng(targetLat, data.lng);
      map.panTo(targetPoint);

      // const proj = map.getProjection();

      // const p = proj.containerPointFromCoords(latlng);
      // const offsetPx = 180;
      // const q = new kakao.maps.Point(p.x, p.y - offsetPx);

      // const newCenter = proj.coordsFromContainerPoint(q);
      // map.panTo(newCenter);
      // const newLat = newCenter.getLat();
      // const newLng = newCenter.getLng();

      // setLatLng({ lat: newLat, lng: newLng });
    }

    // 현재 마커 ID 저장
    prevClickedMarkerId.current = `marker-${id}`;
  }, [map, markerDetail]);

  // 상세 리스트
  useEffect(() => {
    if (!makrerDetailData || !markerDetail || markerDetail.iidx === 0) {
      // 상세 모달 닫기
      // setIsMarkerClicked(false);
      setModalOpen(false);
      return;
    }

    setFilteredDetailData(processData(makrerDetailData, mapFilter.type));
  }, [makrerDetailData, mapFilter]);

  // 상세 모달
  useEffect(() => {
    if (filteredDetailData.length === 0) return;
    // setIsMarkerClicked(true);
    setModalOpen(true);

    const nowHeight = getBottomSheetHeight(filteredDetailData);
    setHeight(nowHeight); // 슬라이드 다시 열릴 때 기본 높이로 복원
    setInitialHeight(nowHeight);
  }, [filteredDetailData]);

  const getSubMarker = (data: any) => {
    try {
      const lat = Number(data.lat);
      const lng = Number(data.lng);

      if (
        isNaN(lat) ||
        isNaN(lng) ||
        Math.abs(lat) > 90 ||
        Math.abs(lng) > 180
      ) {
        return;
      }

      setLatLng({ lat, lng });

      const getLevel = (zoom: number): number => {
        if (zoom >= 10) return 8;
        if (zoom >= 8) return 7;
        if (zoom >= 6) return 3;
        return zoom - 1;
      };
      setZoomLevel(getLevel(zoomLevel));
    } catch (e) {
      console.error('getSubMarker error', e);
    }
  };

  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLatLng({ lat: latitude, lng: longitude });
        },
        (error) => {
          setLatLng({ lat: 37.4934705, lng: 127.0142285 });
        },
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
      setLatLng({ lat: 37.4934705, lng: 127.0142285 });
    }
  };

  const [trafficMarkers, setTrafficMarkers] = useState<any[]>([]);
  const [schoolMarkers, setSchoolMarkers] = useState<any[]>([]);
  const [publicOfficeMarkers, setPublicOfficeMarkers] = useState<any[]>([]);
  const [hospitalMarkers, setHospitalMarkers] = useState<any[]>([]);
  const [placeOverlays, setPlaceOverlays] = useState<any[]>([]);

  // 마커 클리어  함수
  const clearMarkers = (markers: any, setMarkers: any) => {
    markers.forEach((marker: any) => marker.setMap(null));
    setMarkers([]);
  };

  // 입지 조건 마커 및 마커별 정보 카드 생성
  const searchCategoryPlace = (
    category: string,
    svg: string,
    setMarkers: any,
    markers: any[],
  ) => {
    const ps = new kakao.maps.services.Places(map);
    ps.categorySearch(
      category,
      (data: any, status: any) => {
        if (status === kakao.maps.services.Status.OK) {
          clearMarkers(markers, setMarkers);

          const imageSize = new kakao.maps.Size(32, 32);
          const imageOption = { offset: new kakao.maps.Point(12, 24) };

          const customMarkerImage = new kakao.maps.MarkerImage(
            'data:image/svg+xml;base64,' + btoa(svg),
            imageSize,
            imageOption,
          );

          const newMarkers = data.map((place: any) => {
            const marker = new kakao.maps.Marker({
              position: new kakao.maps.LatLng(place.y, place.x),
              map: map,
              image: customMarkerImage,
            });

            kakao.maps.event.addListener(marker, 'click', () => {
              displayPlaceInfo(place, setPlaceOverlays, map);
            });

            return marker;
          });

          setMarkers(newMarkers);
        }
      },
      { useMapBounds: true },
    );
  };

  useEffect(() => {
    if (onTraffic) {
      searchCategoryPlace(
        'SW8',
        trafficMakersSVG,
        setTrafficMarkers,
        trafficMarkers,
      );
    } else {
      clearMarkers(trafficMarkers, setTrafficMarkers);
    }
  }, [onTraffic, zoomLevel, bounds]);

  useEffect(() => {
    if (onSchool) {
      searchCategoryPlace(
        'SC4',
        schoolMarkesSVG,
        setSchoolMarkers,
        schoolMarkers,
      );
    } else {
      clearMarkers(schoolMarkers, setSchoolMarkers);
    }
  }, [onSchool, zoomLevel, bounds]);

  useEffect(() => {
    if (onPublicOffice) {
      searchCategoryPlace(
        'PO3',
        publicOfficeMarkesSVG,
        setPublicOfficeMarkers,
        publicOfficeMarkers,
      );
    } else {
      clearMarkers(publicOfficeMarkers, setPublicOfficeMarkers);
    }
  }, [onPublicOffice, zoomLevel, bounds]);

  useEffect(() => {
    if (onHospital) {
      searchCategoryPlace(
        'HP8',
        hospitalMarkesSVG,
        setHospitalMarkers,
        hospitalMarkers,
      );
    } else {
      clearMarkers(hospitalMarkers, setHospitalMarkers);
      clearMarkers(placeOverlays, setPlaceOverlays);
    }
  }, [onHospital, zoomLevel, bounds]);

  useEffect(() => {
    if (map) {
      // 지도 타입 변경
      map.setMapTypeId(window.kakao.maps.MapTypeId[mapType]);

      map.removeOverlayMapTypeId(window.kakao.maps.MapTypeId.USE_DISTRICT);
      if (overlayType === 'USE_DISTRICT') {
        map.addOverlayMapTypeId(window.kakao.maps.MapTypeId.USE_DISTRICT);
      } else {
        map.removeOverlayMapTypeId(window.kakao.maps.MapTypeId.USE_DISTRICT);
      }
    }
  }, [mapType, overlayType]);

  // 공시지가 데이터
  const [mapPolyData, setMapPolyData] = useState([]);
  const [officialArray2, setofficialArray2]: any = useState([]);

  const officialPrice = async () => {
    let address = selectedAddress;
    if (address.includes('율량동')) {
      address = '충청북도 청주시 청원구 율량동 2021';
    }
    const result = await MapService.officialPrice(address);
    setMapPolyData(result.data);
  };

  useEffect(() => {
    if (
      !onPublicPrice ||
      selectedAddress === '' ||
      !selectedAddress ||
      selectedAddress === '서울특별시 서초구 서초대로 294'
    ) {
      officialArray2.map((el: any) => {
        el.setMap(null);
      });
      return;
    }
    officialPrice();
  }, [onPublicPrice, selectedAddress]);

  // 공시지가 마커 생성(폴리곤)
  useEffect(() => {
    if (onPublicPrice) {
      officialArray2.map((el: any) => {
        el.setMap(null);
      });
      if (mapPolyData.length > 0) {
        mapPolyData.map((el2: any) => {
          const one = el2.geom.map((el: any) => {
            if (Array.isArray(el[0])) {
              return [
                el.map((el: any) => {
                  if (Array.isArray(el[0])) {
                    return el.map((el: any) => {
                      return new kakao.maps.LatLng(el[1], el[0]);
                    });
                  }
                  return new kakao.maps.LatLng(el[1], el[0]);
                }),
                el2.category,
              ];
            }
            return [new kakao.maps.LatLng(el[1], el[0]), el2.category];
          });

          one.map((el: any) => {
            if (el[1] > 0) {
              drawMap(el[0], map, '#0057FF', Math.abs(el[1]), officialArray2);
            } else if (el[1] < 0) {
              drawMap(el[0], map, '#FC2A2A', Math.abs(el[1]), officialArray2);
            } else {
              drawMap(el[0], map, '#535353', 1.5, officialArray2);
            }
          });
        });
      }
    } else {
      officialArray2.map((el: any) => {
        el.setMap(null);
      });
    }
  }, [mapPolyData]);

  return (
    <MapContainer ref={mapRef}>
      <MapWrapper id="newMap" />
      <MapFilter
        onTraffic={onTraffic}
        setOnTraffic={setOnTraffic}
        onSchool={onSchool}
        setOnSchool={setOnSchool}
        onPublicOffice={onPublicOffice}
        setOnPublicOffice={setOnPublicOffice}
        onHospital={onHospital}
        setOnHospital={setOnHospital}
        getUserLocation={getUserLocation}
        bounds={bounds}
        region={region}
        setRegion={setRegion}
      />

      {onRealDealList && (
        <div style={{ zIndex: '99999' }}>
          <RealDealList />
        </div>
      )}
      {modalOpen && (
        <SlideContainer
          $fullHeight={height === 100}
          style={{ height: `${height}dvh` }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {height !== 100 && (
            <SlideHandleWrapper>
              <SlideHandle />
            </SlideHandleWrapper>
          )}
          {height === 100 && (
            <HeaderRegion>
              <img
                src="/assets/images/arrow/back-arrow-left-gray.svg"
                alt=""
                onClick={() => {
                  setHeight(35);
                  setModalOpen(false);
                  setMarkerDetail(null);
                }}
              />
              <span>{region?.gugun}</span> <span>{region?.dong}</span>
            </HeaderRegion>
          )}
          <AuctionComplexItem
            data={filteredDetailData}
            scrollable={height === 100}
            type={mapFilter.type}
            onClose={() => {
              setModalOpen(false);
              setMarkerDetail(null);
            }}
            onToggle={(item: any) => {
              setOnRealDealList(true);
              setIidx(item.idx);
              setModalOn(true);
              setMarkerType(item.type || 'S');
              setMarkerCategory(item.item_code);
            }}
            onDragDownFromTop={() => {
              setHeight(90);
            }}
          />

          {filteredDetailData.length === 0 && (
            <NodataBox>
              <img src="/assets/images/icon/no_data_map_list.svg" alt="" />
              <div>
                <div>
                  <span>현재 위치에 검색된 물건이 없습니다.</span>
                </div>
                <div>지도를 움직이거나 다른 조건으로 검색해주세요.</div>
              </div>
            </NodataBox>
          )}
        </SlideContainer>
      )}
    </MapContainer>
  );
};
export default MapBox;

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: hidden;
`;

const MapWrapper = styled.div`
  width: 100%;
  flex: 1;
  height: 100%;
  position: relative;
`;

// 공간정보 분석  > 입지조건 마커 클릭시 생기는 주소지 정보 생성
const displayPlaceInfo = (place: any, setPlaceOverlays: any, map: any) => {
  const content = `
    <div class="placeinfo">
      <a class="title" href="${place.place_url}" target="_blank" title="${
        place.place_name
      }">${place.place_name}</a>
      ${
        place.road_address_name
          ? `
        <span title="${place.road_address_name}">${place.road_address_name}</span>
        <span class="jibun" title="${place.address_name}">(지번 : ${place.address_name})</span>
      `
          : `
        <span title="${place.address_name}">${place.address_name}</span>
      `
      }
      <span class="tel">${place.phone}</span>
    </div>
    <div class="after"></div>
  `;

  const placeOverlay = new kakao.maps.CustomOverlay({
    content: content,
    position: new kakao.maps.LatLng(place.y, place.x),
    yAnchor: 1,
  });
  placeOverlay.setMap(map);
  setPlaceOverlays((prev: any) => [...prev, placeOverlay]);
};

let themeMarkers: any[] = [];

function drawMap(
  polygonPath: any,
  map: any,
  color: string,
  step: number,
  official?: Array<any> | undefined,
) {
  var polygon = new kakao.maps.Polygon({
    path: polygonPath, // 그려질 다각형의 좌표 배열입니다
    strokeWeight: 0, // 선의 두께입니다
    strokeColor: '#39DE2A', // 선의 색깔입니다
    strokeOpacity: 0.8, // 선의 불투명도 입니다 1에서 0 사이의 값이며 0에 가까울수록 투명합니다
    strokeStyle: 'longdash', // 선의 스타일입니다
    fillColor: color, // 채우기 색깔입니다
    fillOpacity: step * 0.2, // 채우기 불투명도 입니다
  });

  themeMarkers.push(polygon);
  if (official) {
    official.push(polygon);
  }
  // 지도에 다각형을 표시합니다
  polygon.setMap(map);
}

const processData = (data: any, markertype: string) => {
  const markertypeArr =
    markertype && markertype.trim() !== ''
      ? markertype.split(',').map((item: string) => item.trim())
      : ['A', 'P', 'E', 'S'];
  const result: any[] = [];

  // markertype에 'A'가 있으면 auction_list에서 type이 'A'인 항목을 추가
  if (
    (markertypeArr.includes('A') || markertypeArr.includes('N')) &&
    Array.isArray(data.auction_list)
  ) {
    result.push(...data.auction_list.filter((item: any) => item.type === 'A'));
  }

  // markertype에 'P'가 있으면 auction_list에서 type이 'P'인 항목을 추가
  if (markertypeArr.includes('P') && Array.isArray(data.auction_list)) {
    result.push(...data.auction_list.filter((item: any) => item.type === 'P'));
  }

  // markertype에 'E'가 있으면 ex_list 추가
  if (markertypeArr.includes('E') && Array.isArray(data.ex_list)) {
    result.push(...data.ex_list);
  }

  // markertype에 'R', 'S', 'D'가 있으면 realdeal 추가 (realdeal은 객체 혹은 배열일 수 있음)
  if (markertypeArr.some((type) => ['R', 'S', 'D'].includes(type))) {
    if (Array.isArray(data.realdeal)) {
      result.push(...data.realdeal); // realdeal이 배열이면 그대로 추가
    } else if (data.realdeal) {
      result.push(data.realdeal); // realdeal이 객체일 경우 배열로 감싸서 추가
    } else if (data.rent) {
      result.push(data.rent);
    }
  }

  return result;
};

const SlideContainer = styled.div<{ $fullHeight?: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 100dvh;
  background-color: #fff;
  border-top-left-radius: ${({ $fullHeight }) =>
    $fullHeight ? '0px' : '16px'};
  border-top-right-radius: ${({ $fullHeight }) =>
    $fullHeight ? '0px' : '16px'};
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  transition: height 0.2s ease;
  /* overflow: hidden; */
  overflow-y: auto;
  z-index: 2001;
`;

const SlideHandleWrapper = styled.div`
  width: 100%;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SlideHandle = styled.div`
  width: 40px;
  height: 2px;
  background-color: #989ba2;
  border-radius: 2px;
`;

const NodataBox = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  padding: 16px;
  // justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;

  color: #616161;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
  img {
    width: 100px;
    height: 60px;
  }
  span {
    font-weight: 700;
    line-height: 23.2px;
  }
  div {
    justify-content: center;
    align-items: center;
  }
`;

const HeaderRegion = styled.div`
  padding: 12px 16px;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #e1e2e4;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;
